import { useEffect } from 'react';
import { useChatStore } from './useChatStore';

const isMac = () => /Mac|iPhone|iPad/.test(navigator.userAgent);

const isChatShortcut = (event: KeyboardEvent) =>
  !event.repeat &&
  (isMac() ? event.metaKey : event.ctrlKey) &&
  event.key.toLowerCase() === 'e';

// Cmd+E (macOS) bzw. Ctrl+E öffnet und schließt das Chat-Panel
export function useChatShortcut() {
  const toggle = useChatStore((state) => state.toggle);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (isChatShortcut(event)) {
        event.preventDefault();
        toggle();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [toggle]);
}
